import { serverAddr, fileServerAddr } from "../networkConfig";

export default {
    getAllTickets() {
        return serverAddr.post("/get/incident-list/");
    }, 
    createTicket(params) {
        return serverAddr.post("/create-update/incident/", params);
    },
    getAllIncidentReportList(store_id = undefined) {
        if (store_id) {
            return serverAddr.post("/get/incident-report/", {
                store: store_id
            });
        } else {
            return serverAddr.post("/get/incident-report/");
        }
    },
    reportIssue(params) {
        return serverAddr.post("/report/incident/", params);
    },
    getIncidentReportDetails(report_id) {
        return serverAddr.post("/view/incident-report/", {
            incident_id: report_id
        });
    },
    getReportsSummary(params) {
        return serverAddr.post("/incident/summary/", params);
    },
    getAllTicketDepartments() {
        return serverAddr.post("/get/department-list/");
    },
    getStoreUsers(params) {
        return serverAddr.post('/get-users/department/', params);
    },
    updateIncidentReport(params) {
        return serverAddr.post('/update/report-status/', params);
    },
    addTicketAttachment(params) {
        return fileServerAddr.post(`/add/attachment_to_incident/`, params, {
        // return serverAddr.post(`/add/attachment_to_incident/`, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getTicketAttachment(params) {
        return serverAddr.post(`/common/get-attachment-url/`, params);
    },
    deleteAttachment(params) {
        return serverAddr.post('/delete/attachment_to_incident/', params);
    },
    getIncidentsByDepartments(category) {
        return serverAddr.post('/get/incident-list/', {
            "department": category
        });
    },
    getReportsSummaryByLocation(params) {
        return serverAddr.post("/incident/summary/", params);
    },
    getAllOutletStores() {
		return serverAddr.get("/outlet/?get_all=true");
	},
    // New APIs
    getAllIncidentCategory() {
        return serverAddr.get(`/incident/category/?get_all=true`);
    },
    saveNewIncidentCategory(params) {
        return serverAddr.post(`/incident/category/`, params);
    },
    getIncidentTickets() {
        return serverAddr.get(`/incident/ticket/?get_all=true`);
    },
    getIncidentTypeByCategory(category_id) {
        return serverAddr.get(`/incident/type/?get_all=true&category_id=${category_id}`);
    },
    getIncidentReportSummary(params) {
        return serverAddr.post(`/incident/report/summary/`, params);
    },
    // getIncidentReportList(params) {
    //     return serverAddr.post(`/incident/report/dashboard-list/`, params);
    // },
    getIncidentReportList(page,page_size,params) {
        return serverAddr.post(`/incident/report/dashboard-list/?page=${page}&page_size=${page_size}`,params);
    },
    getIncidentReportFilters(params){
        return serverAddr.post(`/incident/report/dashboard-list/filters/`,params);
    },
    getIncidentStepList() {
        return serverAddr.get(`/incident/step/`);
    },
    getAllPriorityList() {
        return serverAddr.get(`/incident/priority/`);
    },
    getAssignTicketUsers(params) {
        return serverAddr.post(`/incident/report/fixers/`, params)
    },
    reportNewIncident(params) {
        return serverAddr.post(`/incident/report/`, params);
    },
    createNewIncidentReport(params) {
        return serverAddr.post(`/incident/ticket/`, params);
    },
    uploadIncidentAttachment(params) {
        return fileServerAddr.post(`/incident/attachment/upload/`, params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    bulkUploadIncidentAttachment(params) {
        return serverAddr.post(`/incident/attachment/bulk/add/update/`, params);
    },
    getIncidentReportAttachments(id) {
        return serverAddr.get(`/incident/report/${id}`);
    },
    getAssignUsers(params) {
        return serverAddr.post(`/incident/report/fixers/`, params);
    },
    updateReportIssueDetails(id, params) {
        return serverAddr.patch(`/incident/ticket/${id}/`, params);
    },
    getAllTicketTypes() {
        return serverAddr.get(`/incident/type/?get_all=true`);
    },
    getAllUserGroups() {
        return serverAddr.get(`/users/user/group/?get_all=true`);
    },
    createNewTicketTypes(params) {
        return serverAddr.post(`/incident/type/`, params);
    },
    getAllUserDesignations() {
        return serverAddr.post(`/users/designations/list/?get_all=true`);
    },
    checkTicketStatusAvailability(params) {
        return serverAddr.post(`/incident/report/status/permission/`, params);
    },
    updateTicketStatus(report_id, params) {
        return serverAddr.patch(`/incident/report/${report_id}/`, params);
    },
    bulkSaveTicketSteps(params) {
        return serverAddr.post(`/incident/ticket-step/bulk/create/update/`, params);
    },
    updateTicketsSLA(priority_id, params) {
        return serverAddr.patch(`/incident/priority/${priority_id}/`, params);
    },
    getUserGroupUsers(params) {
        return serverAddr.post(`/users/user/group/users-list/`, params);
    },
    getAssignToUserListAPI(params){
        return serverAddr.post(`/users/all_users_v1/`, params);
    },
    getUserByDesignaion(params) {
        return serverAddr.post(`/users/designations/users-list/?get_all=true`, params);
    },
    addNewUserGroup(params) {
        return serverAddr.post(`/users/user/group/`, params);
    },
    addUsersToUserGroup(params) {
        return serverAddr.post(`/users/user/group/add-users/`, params);
    },
    deleteUserGroup(group_id) {
        return serverAddr.delete(`/users/user/group/${group_id}`);
    },
    updateUserGroupDetails(user_group_id, params) {
        return serverAddr.patch(`/users/user/group/${user_group_id}`, params);
    },
    removeUsersFromUserGroup(params) {
        return serverAddr.post(`/users/user/group/remove-users/`, params);
    },
    updateTicketTemplate(id, params) {
        return serverAddr.patch(`/incident/type/${id}/`, params);
    },
    deleteExistingTicket(id) {
        return serverAddr.delete(`/incident/type/${id}/`);
    },
    updateIncidentCategory(id, payload) {
        return serverAddr.patch(`/incident/category/${id}/`, payload);
    },
    deleteIncidentCategory(id) {
        return serverAddr.delete(`/incident/category/${id}/`);
    },
    getTicketsDashboardData(params) {
        return serverAddr.post(`/incident/ticket/report/`, params);
    },
}
